// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"939a178b","400":"03e21788"}[chunkId] + ".chunk.js";
};